<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <ServerError v-if="ServerError" />
    <v-layout v-if="productData.length>0" wrap>
      <v-flex pt-4 xs12 xl11>
        <v-layout wrap justify-center>
          <v-flex xs12 lg3 xl3>
            <ProductFilter v-if="loadData" v-bind:filters="filters" @stepper="filterProduct" />
          </v-flex>
          <v-flex px-2 xs12 lg9 xl9>
            <Product
              v-if="loadData"
              v-bind:productData="productData"
              v-bind:pagination="pagination"
              v-bind:sorting="sortType"
              @stepper="winStepper"
              :key="loadTime"
            />
          </v-flex>
          <v-flex py-4 xs12 text-center align-self-center>
            <v-pagination v-model="currentPage" :length="pages" :total-visible="7" color="#63028F" />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout pt-12 wrap justify-center>
      <v-flex xs12 text-center>
        <span style="font-family:opensanssemibold;font-size:20px;color:#464646">{{msg}}</span>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import ProductFilter from "./filters";
import Product from "./product";
export default {
  props: ["searchKey"],
  components: {
    ProductFilter,
    Product,
  },
  data() {
    return {
      appLoading: false,
      ServerError: false,
      productData: {},
      msg: null,
      loadData: false,
      loadTime: 0,
      totalData: 0,
      pages: 0,
      count: 60,
      currentPage: 1,
      sortType: null,
      pagination: {
        pages: 0,
        count: 0,
        startingcount: 0,
        endingcount: 0,
      },
      filters: {
        minPrice: 0,
        maxPrice: 100,
      },
    };
  },
  beforeMount() {
    this.getData();
  },
  watch: {
    currentPage() {
      this.getData();
    },
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/product/search",
        data: {
          // category: null,
          // subcategory: null,
          // availability: null,
          lowerprice: this.filters.minPrice,
          upperprice: this.filters.maxPrice,
          // seller: null,
          // ratings: null,
          // discount: null,
          // onlyseasonal: null,
          count: this.count,
          page: this.currentPage,
          keyword: this.searchKey,
          sort: this.sortType,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.loadTime = this.loadTime + 1;
            this.productData = response.data.data;
            this.pages = response.data.pages;
            this.totalData = response.data.count;
            this.pagination.pages = response.data.pages;
            this.pagination.count = response.data.count;
            this.pagination.startingcount = response.data.startingcount;
            this.pagination.endingcount = response.data.endingcount;
            this.filters.maxPrice = response.data.highestprice;
            this.loadData = true;
          } else {
            this.msg = "We didn't found any product you are looking for";
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    winStepper(window_data) {
      this.currentPage = 1;
      this.sortType = window_data.sort;
      this.getData();
    },
    filterProduct(item) {
      console.log(item);
      this.filters.minPrice = item.priceRange[0];
      this.filters.maxPrice = item.priceRange[1];
      this.getData();
    },
  },
};
</script>